import { useEffect } from "react";
import { Box } from "@mui/material";
import { useLocation } from "react-router-dom";
import { getSafeWorkspacePage, SafeWorkspaceContext } from "../components/RISK_ASSESSMENT/components/common/safeWorkspace";
import "../components/RISK_ASSESSMENT/styles/safeWorkspace.css";

export default function SafeWorkerLayout({ children }) {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = '안전관리 시스템';
    return () => {
      if (document.title === '안전관리 시스템') document.title = previousTitle;
    };
  }, []);
  const { pathname } = useLocation();
  const page = getSafeWorkspacePage(pathname);

  return (
    <Box className="safe-app-font-scope" sx={{ minWidth: 0 }}>
      <Box
        component="main"
        aria-label="안전관리 본문"
        className="safe-workspace"
        data-safe-page={page?.path}
        sx={{ minHeight: "100dvh", minWidth: 0 }}
      >
        <SafeWorkspaceContext.Provider value={page}>
          {children}
        </SafeWorkspaceContext.Provider>
      </Box>
    </Box>
  );
}
